import { Injectable } from '@angular/core';
import { GenericResponse } from './../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({ providedIn: 'root' })
export class CallerDataService {
    constructor(
        private dataProvider: DataService
    ) {}
    getCallerInfo(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetCallerInfo,model).toPromise();
    }
    getCallerVehicle(customerId: number, customerGuid: string): Promise<GenericResponse<any>>{
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCallerVehicle,customerId, customerGuid).toPromise();
    }
    getCallHistory(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetCallHistory,model).toPromise();
    }
    addCallHistory(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddCallHistory, model).toPromise();
    }
    saveCallNote(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.SaveCallNote, model).toPromise();
    }
    callDial(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CallDial, model).toPromise();
    }
    callTransfer(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CallTransfer, model).toPromise();
    }
    callHangup(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CallHangup, model).toPromise();
    }
    updateCallEnd(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateCallEnd, model).toPromise();
    }
    updateCallEndAll(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateCallEndAll, model).toPromise();
    }
}